/**
 * Etiquetas de formulario.
 *
 * Sin este tema heredaban el tamaño de cuerpo del sitio público
 * (clamp 16–18px), desproporcionado dentro de la escala compacta del
 * panel. Cada pantalla lo compensaba con su propio `fontSize` inline, y
 * de ahí que Productos y Proyectos acabaran con estilos distintos.
 * Definirlo una vez es lo que hace que el estilo sea único.
 */
const FormLabel = {
  baseStyle: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'text.primary',
    marginBottom: '6px',
    lineHeight: 1.4,
  },
};

export default FormLabel;
